import {Component} from "@angular/core";
import {DOCUMENT_TYPES, VALUE_TYPE} from "../../enums/enums";
import {MODIFIERS_TYPES_LIST} from "../../enums/e-modifiers";
import {SOURCE_TYPES_LIST} from "../../enums/e-sources";
import {BusService} from "../../services/bus.service";
import {paramsHelper} from "../../helpers/params-helper";
import {UI_TEXTS} from "../../enums/e-texts";
import {IDocument} from "../../interfaces/document.definition";
import {SEARCH_PROP_TYPES} from "../../enums/e-search";
import {localeUtils} from "../../helpers/locale-utils";


@Component({
  templateUrl: "./buffs-page.component.html"
})


export class BuffsPageComponent {
  MODIFIERS_TYPES_LIST = MODIFIERS_TYPES_LIST;
  SOURCE_TYPES_LIST = SOURCE_TYPES_LIST;
  VALUE_TYPE = VALUE_TYPE;
  UI_TEXTS = UI_TEXTS;

  pageParams = paramsHelper.page()
    .setTitle("Баффы");

  collectionParams = paramsHelper.collection()
    .setObjectType(DOCUMENT_TYPES.BUFF)
    .setDefaultListLabels()
    //.setItemLabelQuery(`locales.${localeUtils.getLocale()}.[key=name].value.0`)
	.setItemLabelQuery('codeName')
    .setSearchParams(paramsHelper.search()
      .addParam(`locales.${localeUtils.getLocale()}.name`, SEARCH_PROP_TYPES.LOCALE, "")
      .addStringParam("name")
      .addParam('codeName', SEARCH_PROP_TYPES.STRING, ""));

  document: IDocument;


  constructor(private busService: BusService) {
    this.busService.onDocumentUpdated
      .subscribe(
        e => this.document = e.document);
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/buffs/buffs-page.component.ts